import type { FileForm, SignedFile } from '~/models/FileForm'
import { apiClient } from '~/api/client/apiClient'

export function useFileUploadApi() {
  const createFileUploadForm = async (): Promise<FileForm> => {
    return (await apiClient.post('file/form', {})).data
  }

  const createPreSignedFile = async (key: string): Promise<SignedFile> => {
    return (await apiClient.post('file/sign', { key })).data
  }

  return {
    createFileUploadForm,
    createPreSignedFile,
  }
}
